import { Component, h } from 'preact'
import Icon from '../assets'
import Phrase from '../../libs/translationsUtils/phrase'
import PublicTagSelect from '../public-tag/PublicTagSelect'
import { DropdownSelectizeInput } from '../dropdown/DropdownSelectize'
import Axios from 'axios'
import Button from '../../control-components/ui-components/Button'
import { common } from '../common'

interface Props {
  topicId: string,
  canUserEdit: boolean,
  tags: Array<string>,
  contentType: 'ideas' | 'productUpdates' | 'articles',
  onChange: (newTags: Array<string>) => void
}

interface State {
  tags: Array<string>,
  editEnabled: boolean,
  isLoading: boolean
}

class TopicPublicTags extends Component<Props, State> {
  private savedTags: Array<string> = []
  private isPublicTagManagementEnabled: boolean = common.isModuleActive('publicTagManagement')
  constructor (props: Props) {
    super(props)
    this.state = {
      editEnabled: false,
      tags: props.tags,
      isLoading: false
    }
    this.savedTags = props.tags
    this.onChangePublicTags = this.onChangePublicTags.bind(this)
  }

  async onChangePublicTags (isSave: boolean) {
    if (isSave) {
      this.setState({ isLoading: true })
      try {
        await Axios.post(`/community/api/${this.props.contentType}/${this.props.topicId}/editTags`, {
          tags: this.state.tags
        })
        this.savedTags = this.state.tags
        this.setState({ isLoading: false })
      } catch {
        this.setState({ isLoading: false })
      }
    }
    this.props.onChange(this.savedTags)
    this.setState({ editEnabled: false, tags: this.savedTags })
  }

  render ({ canUserEdit, onChange }: Props, { tags, editEnabled, isLoading }: State) {
    return (
      <div className='topic-public-tags-list m-v'>
        {
          !editEnabled ? (
            <ul className='public-tags list list--float js-collapsable--content qa-tags-list'>
              {
                tags.map(tag => <li>
                  <a href={`/search?q=${tag}&search_type=tag`} className='tag--pill qa-tag-pill'>{tag}</a>
                </li>)
              }
              {
                canUserEdit ? (
                  <li className='canEditTags' onClick={() => this.setState({ editEnabled: true })}>
                    <Icon icon='add' size={14} /><Phrase p='Modify tags' />
                  </li>
                ) : null
              }
            </ul>
          ) : (
            <div className='public-tag-edit'>
              {
                this.isPublicTagManagementEnabled ? (
                  <PublicTagSelect
                    isEdit={false}
                    onChange={(newTags) => this.setState({ tags: newTags })}
                    selectedPublicTags={tags.join(',')}
                    inputName='form-control qa-topic-creator-public-tags-input'
                    canEndUserAddPublicTags
                    iconSize={12} />
                ) : <DropdownSelectizeInput
                  items={[]}
                  single={false}
                  class='form-control qa-topic-creator-public-tags-input'
                  placeholder='Add tags to help readers easily find this product update'
                  selectedItems={tags && tags.length ? tags : (tags || [])}
                  onChange={(newTags) => this.setState({ tags: newTags })} />
              }
              <div className='public-tag-edit-buttons'>
                <Button
                  qaClasses='btn btn--cancel js-collapsable--trigger btn--S qa-button-tags-cancel'
                  cancel
                  onClick={() => this.onChangePublicTags(false)}>
                  <Phrase p='Cancel' m='Forum' />
                </Button>
                <Button
                  loading={isLoading}
                  qaClasses='btn btn--S btn--cta save-public-tag qa-button-tags-save'
                  primary
                  onClick={() => this.onChangePublicTags(true)}>
                  <Phrase p='Save' m='Forum' />
                </Button>
              </div>
            </div>
          )
        }
      </div>
    )
  }
}

export default TopicPublicTags
